import { render, staticRenderFns } from "./Governance.vue?vue&type=template&id=6d7bc2a6&scoped=true"
import script from "./Governance.vue?vue&type=script&lang=js"
export * from "./Governance.vue?vue&type=script&lang=js"
import style0 from "./Governance.vue?vue&type=style&index=0&id=6d7bc2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7bc2a6",
  null
  
)

export default component.exports